import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { EditorModule } from 'src/app/editor/editor.module';
import { ImageUploadModule, SharedModule } from '../shared.module';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DocPreviewComponent } from '../component/doc-preview/doc-preview.component';
import {
  ButtonComponent,
  ButtonGroupComponent,
} from './component/button/button.component';
import { ConfirmModalComponent } from './component/confirm-modal/confirm-modal.component';
import { DynamicTableFormComponent } from './component/dynamic-table-form/dynamic-table-form.component';
import { FormDocComponent } from './component/form-doc/form-doc.component';
import { FormGeneratorComponent } from './component/form-generator/form-generator.component';
import { FormTableFilterComponent } from './component/form-table-filter/form-table-filter.component';
import { TableListComponent } from './component/table-list/table-list.component';
import { ConditionOperatorPipe } from './pipe/condtion-operator.pipe';
import { CurrencyFormatPipe } from './pipe/currency-format.pipe';
import { FormControlActionPipe } from './pipe/form-control-action.pipe';
import { TransformArrayPipe } from './pipe/transform-array.pipe';
import { FormArrayComponent } from './component/form-array/form-array.component';
const comp = [
  ConfirmModalComponent,
  FormGeneratorComponent,
  TableListComponent,
  ConditionOperatorPipe,
  TransformArrayPipe,
  FormControlActionPipe,
  DynamicTableFormComponent,
  FormDocComponent,
  CurrencyFormatPipe,
  ButtonGroupComponent,
  ButtonComponent,
  FormTableFilterComponent,
  FormArrayComponent,
];

@NgModule({
  declarations: [comp],
  providers: [ConditionOperatorPipe],
  exports: [comp, DocPreviewComponent],
  imports: [
    CommonModule,
    MultiSelectModule,
    RadioButtonModule,
    TableModule,
    DropdownModule,
    AutoCompleteModule,
    ColorPickerModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    ImageUploadModule,
    ChipsModule,
    EditorModule,
    KeyFilterModule,
    SharedModule,
    ButtonModule,
    AutoCompleteModule,
    DocPreviewComponent
  ],
})
export class FormHelperModule {}
